// Gecici ornek takim (destek grubu) listesi. Backend getSupportGroups() gercek
// veri dondurunce ref/ad eslestirilir; uyeler/lider gibi zengin alanlar mock kalir.

export interface TeamMember {
    name: string;
    role: string;
}

export interface Team {
    ref: number;
    name: string;
    description: string;
    lead: string;
    members: TeamMember[];
    openTickets: number;
    is_active: boolean;
}

export const MOCK_TEAMS: Team[] = [
    {
        ref: 1,
        name: "Destek Ekibi",
        description: "Uzaktan müşteri desteği ve ticket çözümü",
        lead: "Kadir Coşkun",
        members: [
            { name: "Kadir Coşkun", role: "Takım Lideri" },
            { name: "Ahmed Enes Demiryürek", role: "Destek Uzmanı" },
            { name: "Rahime Kalkan", role: "Destek Uzmanı" },
            { name: "Şevket Çelikkaya", role: "Destek Uzmanı" },
            { name: "Ayhan Dölek", role: "Destek Uzmanı" },
        ],
        openTickets: 18,
        is_active: true,
    },
    {
        ref: 2,
        name: "Yazılım Ekibi",
        description: "Ürün geliştirme ve teknik eskalasyon",
        lead: "Kadir Coşkun",
        members: [
            { name: "Kadir Coşkun", role: "Takım Lideri" },
            { name: "Arif Uçar", role: "Yazılım Geliştirici" },
            { name: "Muhammed", role: "Yazılım Geliştirici" },
            { name: "Kasım", role: "Yazılım Geliştirici" },
        ],
        openTickets: 7,
        is_active: true,
    },
    {
        ref: 3,
        name: "Saha Operasyon",
        description: "Saha kurulum ve müşteri ziyaretleri",
        lead: "Kadir Coşkun",
        members: [
            { name: "Kadir Coşkun", role: "Takım Lideri" },
            { name: "Ayhan Dölek", role: "Saha Sorumlusu" },
            { name: "Şevket Çelikkaya", role: "Saha Uzmanı" },
        ],
        openTickets: 3,
        is_active: false,
    },
];

export function resolveTeam(ref: number | string | undefined, list: Team[]): Team | null {
    if (ref == null || ref === "") return null;
    const pool = list.length ? list : MOCK_TEAMS;
    return pool.find(tm => String(tm.ref) === String(ref)) ?? null;
}
